import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";
import CuentaSocioTransferencia from "../../generico/CuentaSocioTransferencia";
import { splitImporte } from "../../generico/utils/FormatoInput";
import Popup from "react-popup";
import PronetTitulo from "./PronetTitulo"
import history from "../login/history";
import CabeceraWizard from "./CabeceraWizard"
import $ from "jquery";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import TransferInterbancaService from "../../../services/transferencias/TransferInterbancaService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";

export default class PronetPaso3 extends Component {
  muestraEntrust = false;
  muestraOtp = false;
  muestraSoloPin = false;
  constructor(props) {
    super(props);
    this.state = {
      codigo: props.codigo,
      datosFormulario: props.resultadoPaso1,
      monto: 0,
      optionsCuentas: [],
      itemSelected: [],
      cuentasOrigen: [],
      disableSgte: true

    };
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {

  }

  selectorValue = (dataFromChild, item) => {
    var respChild = JSON.stringify(dataFromChild)
   // console.log("VALOR QUE SELECCIONA EN CUENTA "+respChild)
    if ($('#btn-next-paso3').is(':disabled')) {
      $('#btn-next-paso3').removeAttr('disabled');
    }
    if (respChild === "{}") {

      this.setState({
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.ahorro,
        saldoActual: dataFromChild.saldoTotal,
        detalleCuenta: dataFromChild.ahorro + " " + dataFromChild.descripcion,
        itemSelected: item,

      });
      $('#btn-next-paso3').attr('disabled', 'true');
 //     return;
    }
    var valor = undefined;
    var num = undefined;
    var saldo = undefined;
    if (this.props.paso2 !== undefined && this.props.paso1 !== undefined) {
      //  console.log("VALIDAR PASO 3  ES DESDE PASO 2 " + JSON.stringify(this.props.paso2))
      var jsonData = JSON.parse(JSON.stringify(this.props.paso2));
      for (var i = 0; i < jsonData.length; i++) {
        var datos = JSON.parse(JSON.stringify(jsonData[i]));

        if (datos.debitable === "true") {
          valor = splitImporte(datos.value);
           num = parseInt(valor);
           saldo = parseInt(dataFromChild.saldoTotal)
          if (num > saldo) {
            $('#btn-next-paso3').attr('disabled', 'true');
            Popup.queue(this.notifiPopup("Info", "El monto que desea pagar es mayor a su disponible"));
            return;
          }
         


        }


      }
      this.setState({
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.ahorro,
        saldoActual: dataFromChild.saldoTotal,
        detalleCuenta: dataFromChild.ahorro + " " + dataFromChild.descripcion,
        itemSelected: item,

      });
      this.props.respuestaPaso3(JSON.parse(JSON.stringify(dataFromChild)), num, this.props.paso2);

    }
    if (this.props.paso1 !== undefined && this.props.paso2 === undefined) {
      //  console.log("VALIDAR PASO 3  ES DESDE PASO 1 " + JSON.stringify(this.props.paso1))
      var jsonData = JSON.parse(JSON.stringify(this.props.paso1));
      for (var i = 0; i < jsonData.length; i++) {
        var datos = JSON.parse(JSON.stringify(jsonData[i]));

        if (datos.debitable === "true") {
           valor = splitImporte(datos.value);
           num = parseInt(valor);
           saldo = parseInt(dataFromChild.saldoTotal)
          //console.log("valores "+num+ " saldo "+saldo)
          if (num > saldo) {
            $('#btn-next-paso3').attr('disabled', 'true');
            Popup.queue(this.notifiPopup("Info", "El monto que desea pagar es mayor a su disponible"));
            return;
          }
          this.setState({
            cuentaOrigenSelected: dataFromChild,
            cuentaDebito: dataFromChild.ahorro,
            saldoActual: dataFromChild.saldoTotal,
            detalleCuenta: dataFromChild.ahorro + " " + dataFromChild.descripcion,
            itemSelected: item,

          });
          this.props.respuestaPaso3(JSON.parse(JSON.stringify(dataFromChild)), num, this.props.paso1);
        }

      }
    }

  };
  montoValue = (dataFromChild) => {
    // console.log(dataFromChild)

    this.setState({
      monto: dataFromChild,
    });
  };

 

  getOptionsCuentas(item) {
    var options = [];

    for (var i = 0; i < item.length; i++) {
      options.push({
        value: item[i].ahorro,
        label:
          item[i].ahorro +
          "-" +
          item[i].descripcion +
          "-" +
          " Saldo: " +
          item[i].saldoTotal + " " +
          item[i].moneda +
          ".",
      });
    }
    this.setState({ optionsCuentas: options });
  }


  getCuentasSocio() {
    
    if ($('#btn-next-paso3').is(':disabled')) {
      $('#btn-next-paso3').removeAttr('disabled');
    }
    if(this.props.nroCuenta === undefined)
    $('#btn-next-paso3').attr('disabled', 'true');
    trackPromise(
      PagoServicioService.getCuentasSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === '0') {
            this.setState({ cuentasOrigen: jsonData.resultadoAH });
            this.getOptionsCuentas(jsonData.resultadoAH);
          }
        },
          error => {
            const resMessage = error.codDescripcion;
            this.setState({
              loading: false,
              message: resMessage
            });
            //  this.modalControl.click();
          }
        ));
  }
  detalles() {

    if (this.state.optionsCuentas.length === 0) {

      this.getCuentasSocio()

    }
  }

  validarPaso3 = (e) => {
    // if (this.props.paso2 !== undefined && this.props.paso1 !== undefined) {
      //  // console.log("LA CUENTA ES"+this.state.cuentaOrigenSelected);
      //   this.props.respuestaPaso3(this.state.cuentaOrigenSelected, null, this.props.paso2);
      // }
      // if (this.props.paso1 !== undefined && this.props.paso2 === undefined) {
      //   this.props.respuestaPaso3(this.state.cuentaOrigenSelected, null, this.props.paso1);
      // }
    this.verificarEntrustyPin();
    if( !this.muestraEntrust ){
      if( this.muestraSoloPin ){
        if( this.props.paso1 !== undefined ){
          this.props.paso2 === undefined ? 
          this.props.respuestaPaso3(this.state.cuentaOrigenSelected,null,this.props.paso1,null,"") :
          this.props.respuestaPaso3(this.state.cuentaOrigenSelected,null,this.props.paso2,null,"") ;
          this.props.goToStep(5);
        }else{
          Popup.queue(this.notifiPopup("Error", 'Algo salió mal.'));
          console.log('Error, paso1=undefined');  
        }
      }else{
        Popup.queue(this.notifiPopup("Error", 'Para completar esta operación, por favor activa un token de seguridad en tu cuenta'));  
      }
    }else{
      if( this.props.paso1 !== undefined ){
        // if ( this.muestraEntrust ) {
          this.props.paso2 === undefined ? 
          this.props.respuestaPaso3(this.state.cuentaOrigenSelected, null, this.props.paso1,this.muestraEntrust,"") : 
          this.props.respuestaPaso3(this.state.cuentaOrigenSelected, null, this.props.paso2,this.muestraEntrust,"");
          this.step3.click();
        // }
      }else{
        Popup.queue(this.notifiPopup("Error", 'Algo salió mal.'));
        console.log('Error, paso1=undefined');  
      }
    }
  };

  handleEnter(e) {
    if(e.keyCode === 13) {
      e.preventDefault();
    }
  }

  volver = (e) => {
    
   
    this.setState({ optionsCuentas: [], cuentaOrigenSelected: [] });
    if (this.props.paso2 !== null && this.props.paso1 !== null) {
   //   console.log("LA CUENTA ES"+this.state.cuentaOrigenSelected);
          this.step2.click();
    }
    if (this.props.paso1 !== null && this.props.paso2 === undefined) {
     
      this.step1.click();
    }
  };

  volverPagoServicio = (e) => {
    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicio")?.url);
    window.location.reload();
  }

  verificarEntrustyPin = () => {
    const tokenActivo = sessionStorage.getItem('tieneToken');

    tokenActivo === "S" && ConfigService.ocultarSegunNombre("serviciosEntrust") === null ? 
    this.muestraEntrust=true : this.muestraEntrust=false;

    ConfigService.ocultarSegunNombre("ServiciosSoloPin") === null ? 
    this.muestraSoloPin = true : this.muestraSoloPin = false;
    // this.muestraOtp = true : this.muestraOtp = false;
  }


  render() {
    if (this.props.currentStep !== 3) { // Prop: The current step
      return null
    }
    if (this.props.currentStep === 3) {

      this.detalles()

    }
    return (
      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <CabeceraWizard
            nombre={this.props.nombre}
            tittle1="disabled"
            tittle2="disabled"
            tittle3="current"
            tittle4="disabled"
            tittle5="disabled"
            tittle6="disabled"
          />
          {/* <div className="steps clearfix" style={{ marginBottom: 5 }}>
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">{this.props.nombre}</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de confirmación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">5</span>
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div> */}
        </div>

        <PronetTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr />

        {/******************* LOGICA PASOS ***********************/}
        <form id="idPronetPaso3" onSubmit={(e) => e.preventDefault()} onKeyDown={this.handleEnter}>
       
          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <CuentaSocioTransferencia
                renderMonto="false"
                selectorValue={this.selectorValue.bind(this)}
                montoValue={this.montoValue.bind(this)}
                operacion="DEBITO"
                tipoCuenta="AHORRO_VISTA"
                items={this.state.cuentasOrigen}
                monto={this.state.monto}
                itemSelected={this.state.itemSelected}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4 btn-consulta">
            <button className="btn btn-cu-secundary" onClick={this.volverPagoServicio}><FontAwesomeIcon icon={faMoneyCheckDollar} /> Pagar Otro Servicio</button>
            </div>
            <div className="col-md-4 btn-consulta">
            <button className="btn btn-cu-quintary" onClick={this.volver} ><FontAwesomeIcon icon={faArrowLeft} /> Volver</button>
            </div>
            <div className="col-md-4">
              <button id="btn-next-paso3" className="btn btn-cu-primary" onClick={this.validarPaso3}>Continuar <FontAwesomeIcon icon={faArrowRight} /> </button>
              
            </div>
          </div>

          <button
            hidden
            ref={(a) => (this.step3 = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
          ></button>
          <button
            hidden
            ref={(a) => (this.step2 = a)}
            className="btn btn-cu-primary"
            onClick={this.props.previousStep}
          ></button>
          <button
            hidden
            ref={(a) => (this.step1 = a)}
            className="btn btn-cu-primary"
            onClick={() => this.props.goToStep(1)}
          ></button>
        </form>
      </div>
    );
  }
}